module.exports = __webpack_public_path__ + "img/gb.90e00d0e.svg";